// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"VehicleScreen_buttonsContainer__oLKFr","button":"VehicleScreen_button__GdhFI"};